import {IconHelpCircle, IconMicrophone, IconVideo} from "@tabler/icons-react";

export const audioProfiles = {
  guitar: {
    label: "Гитара",
    description: "Стерео-профиль без агрессивной обработки, чтобы сохранить атаку струн и тембр.",
    settings: {
      autoGainControl: false,
      echoCancellation: true,
      noiseSuppression: false,
      channelCount: "2",
      latency: "0.01",
      sampleRate: "48000",
      sampleSize: "16",
    },
  },
  piano: {
    label: "Пианино",
    description: "Стерео-профиль с упором на динамику и естественный диапазон инструмента.",
    settings: {
      autoGainControl: false,
      echoCancellation: true,
      noiseSuppression: false,
      channelCount: "2",
      latency: "0.01",
      sampleRate: "48000",
      sampleSize: "16",
    },
  },
  vocals: {
    label: "Вокал",
    description: "Стерео-профиль без обработки, чтобы не давить обертона и дыхание исполнителя.",
    settings: {
      autoGainControl: false,
      echoCancellation: true,
      noiseSuppression: false,
      channelCount: "2",
      latency: "0.01",
      sampleRate: "48000",
      sampleSize: "16",
    },
  },
  winds: {
    label: "Духовые",
    description: "Стерео-профиль с низкой задержкой для сохранения атаки и воздушности звучания.",
    settings: {
      autoGainControl: false,
      echoCancellation: true,
      noiseSuppression: false,
      channelCount: "2",
      latency: "0.01",
      sampleRate: "48000",
      sampleSize: "16",
    },
  },
  drums: {
    label: "Ударные",
    description: "Стерео-профиль для передачи атаки, транзиентов и общего баланса установки.",
    settings: {
      autoGainControl: false,
      echoCancellation: true,
      noiseSuppression: false,
      channelCount: "2",
      latency: "0.01",
      sampleRate: "48000",
      sampleSize: "16",
    },
  },
  violin: {
    label: "Скрипка",
    description: "Стерео-профиль с акцентом на читаемость середины и верхние гармоники.",
    settings: {
      autoGainControl: false,
      echoCancellation: true,
      noiseSuppression: false,
      channelCount: "2",
      latency: "0.01",
      sampleRate: "48000",
      sampleSize: "16",
    },
  },
};

export const settingsSections = [
  { key: "sound", label: "Звук", mobileLabel: "Звук", icon: IconMicrophone },
  { key: "video", label: "Видео", mobileLabel: "Видео", icon: IconVideo },
  {
    key: "support",
    label: "Справка и поддержка",
    mobileLabel: "Справка",
    icon: IconHelpCircle,
  },
];


export const AUDIO_DEBOUNCE_MS = 500;

export const audioBitrateOptions = [
  {
    value: "auto",
    label: "Авто",
    description: "Битрейт подбирается автоматически.",
  },
  {
    value: "highest",
    label: "Высочайшее",
    description: "Максимальное качество звука.",
  },
  {
    value: "traffic-saving",
    label: "Экономия трафика",
    description: "Пониженный битрейт для нестабильной сети.",
  },
];

export const audioBitrateValues = {
  auto: undefined,
  highest: 190_000,
  "traffic-saving": 64_000,
};

export const buildAudioPublishPreset = (selectedAudioBitrate) => {
  const maxBitrate = audioBitrateValues[selectedAudioBitrate];

  return maxBitrate
    ? {
        maxBitrate,
        priority: "high",
      }
    : {
				maxBitrate: 130_000,
        priority: "high"
      };
};
